import React from 'react';
import { IconButton } from 'UI';
import { connect } from 'react-redux';
import { edit, init } from 'Duck/customMetrics';
function CustomMetrics(props) {
    return (React.createElement("div", { className: "self-start" },
        React.createElement(IconButton, { plain: true, outline: true, icon: "plus", label: "CREATE METRIC", onClick: function () { return props.init(); } })));
}
export default connect(null, { edit: edit, init: init })(CustomMetrics);
